import {getheaders} from './authService';

async function request(path = '', options = {}) {
    const response = await fetch(`/api/job-type-options${path}`, {headers: getheaders(), cache: 'no-store', ...options});
    const body = await response.json();
    if (!response.ok) throw new Error(body.message || 'Unable to load or save Job Types.');
    return body;
}

export const getJobTypeOptions = (includeInactive = false) => request(includeInactive ? '?include_inactive=true' : '');
export const saveJobTypeOption = value => request(value.id ? `/${value.id}` : '', {
    method: value.id ? 'PUT' : 'POST',
    body: JSON.stringify({name: value.name, status: value.status}),
});

export function cleaningTypeLabel(job) {
    return String(job?.job_type).toLowerCase() === 'task' ? 'Task' : job?.cleaning_type_name || 'Airbnb Clean';
}
